module.exports = __webpack_public_path__ + "img/KK0042C-BL.09967fa0.jpg";